<div class="tutorial-container" (click)="dismiss()">
  <div class="tutorial-box" id="tutorial-box"></div>
  <div class="tutorial-text" id="tutorial-text"></div>
</div>
